/* =============================================================================
   Cygnuss Search Tabs — página de resultados /search
   - Marca a pill ativa (inclui o caso Coleções, lido de ?cyg=collections)
   - Busca a contagem dos tipos não-ativos via Section Rendering API
     (/search?q=...&type=...&section_id=cygnuss-search-count) e preenche os badges
   - "Tudo" = produto + artigo + página
   - Marca pills com 0 resultados (.cyg-tab--empty)
   Aditivo: não altera markup dos resultados nem do modal do header.
   ============================================================================= */
(function () {
  'use strict';

  var tabs = document.querySelector('[data-cyg-tabs]');
  if (!tabs) return;

  var term = tabs.getAttribute('data-cyg-term') || '';
  var serverActive = tabs.getAttribute('data-cyg-active') || 'all';
  var params = new URLSearchParams(window.location.search);
  var isCollections = params.get('cyg') === 'collections';
  var activeType = isCollections ? 'collection' : serverActive;

  // ---- 1) Pill ativa (uniforme; sobrepõe o servidor quando em Coleções) -----
  var pills = tabs.querySelectorAll('.cyg-tab');
  for (var i = 0; i < pills.length; i++) {
    var t = pills[i].getAttribute('data-cyg-type');
    if (t === activeType) {
      pills[i].classList.add('cyg-tab--active');
    } else {
      pills[i].classList.remove('cyg-tab--active');
    }
  }

  // ---- 2) Contagens ---------------------------------------------------------
  function countSpan(type) {
    return tabs.querySelector('[data-cyg-type="' + type + '"] [data-cyg-count]');
  }

  function setCount(type, n) {
    var span = countSpan(type);
    if (span) {
      span.textContent = String(n);
      span.classList.remove('cyg-tab__count--loading');
    }
    var pill = tabs.querySelector('[data-cyg-type="' + type + '"]');
    if (pill) {
      if (Number(n) === 0) {
        pill.classList.add('cyg-tab--empty');
      } else {
        pill.classList.remove('cyg-tab--empty');
      }
    }
  }

  var counts = { product: null, article: null, page: null };

  function maybeAll() {
    if (counts.product === null || counts.article === null || counts.page === null) return;
    var allSpan = countSpan('all');
    // Só calcula "Tudo" no cliente se o servidor não tiver mandado (aba Tudo ativa)
    if (allSpan && !allSpan.getAttribute('data-cyg-count-server')) {
      setCount('all', counts.product + counts.article + counts.page);
    }
  }

  ['product', 'article', 'page'].forEach(function (type) {
    var span = countSpan(type);
    var serverVal = span ? span.getAttribute('data-cyg-count-server') : null;

    if (serverVal !== null && serverVal !== '') {
      counts[type] = parseInt(serverVal, 10) || 0;
      setCount(type, counts[type]);
      maybeAll();
      return;
    }

    var url =
      window.location.pathname +
      '?q=' + encodeURIComponent(term) +
      '&type=' + type +
      '&section_id=cygnuss-search-count';

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html && html.match(/data-cyg-count-value[^>]*>\s*(\d+)/);
        var n = m ? parseInt(m[1], 10) : 0;
        counts[type] = n;
        setCount(type, n);
        maybeAll();
      })
      .catch(function () {
        counts[type] = 0;
        setCount(type, 0);
        maybeAll();
      });
  });
})();
